import React, { useRef } from 'react';
import { Box } from '@mui/material';
import EmailEditor from 'react-email-editor';
import { DEFAULT_EMAIL_TOOL_SETTINGS } from '@/components/UnlayerEditorWrapper/constants';
import { useUnlayerEditorLifecycle } from '@/components/UnlayerEditorWrapper/useUnlayerEditorLifecycle';
import { useUnlayerSignatureInsertion } from '@/components/UnlayerEditorWrapper/useUnlayerSignatureInsertion';

// Pin the version of unlayer to a specific version to avoid unexpected breaking changes from unlayer updates
const UNLAYER_EDITOR_VERSION = '1.402.0';

/**
 * Hosts the Unlayer editor instance and synchronizes editor state with parent form state.
 */
export const UnlayerEditorWrapper = ({
	minHeight = 420,
	initialDesign = null,
	designToLoad = null,
	mergeTags = {},
	onProgrammaticDesignLoad = () => {},
	signatureInsertRequest = null,
	displayMode = 'email',
	onEditorReady = () => {},
	onChange = () => {},
}) => {
	const editorRef = useRef(null);
	const { handleReady, editorReadyRevision, flushDesignChangeAfterProgrammaticLoad } =
		useUnlayerEditorLifecycle({
			editorRef,
			onChange,
			onEditorReady,
			mergeTags,
			initialDesign,
			designToLoad,
			displayMode,
			onProgrammaticDesignLoad,
		});

	useUnlayerSignatureInsertion({
		editorReadyRevision,
		editorRef,
		signatureInsertRequest,
		flushDesignChangeAfterProgrammaticLoad,
	});
	return (
		<Box
			sx={{
				minHeight,
				border: '1px solid',
				borderColor: 'divider',
				borderRadius: 1,
				overflow: 'hidden',
			}}
		>
			<EmailEditor
				ref={editorRef}
				minHeight={minHeight}
				onReady={handleReady}
				options={{
					displayMode,
					projectId: 284447,
					version: UNLAYER_EDITOR_VERSION,
					...(displayMode === 'email' ? DEFAULT_EMAIL_TOOL_SETTINGS : {}),
				}}
			/>
		</Box>
	);
};
